// Tiny pub/sub used to surface app-wide toast notifications.
//
// `notify()` is callable from non-React code (e.g. the axios interceptor in
// authedAxios.js); the <Notifier/> component subscribes and renders the toast.
const listeners = new Set();

export function notify(message, severity = "error") {
  for (const listener of listeners) listener({ message, severity });
}

export function subscribeNotify(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
